<template>
    <v-touch @swiperight="swiperright" class="wrapper">
        <div class="collectionSelectContract">
            <van-nav-bar
                title="选择合同"
                left-text="收款记录"
                left-arrow
                @click-left="swiperright"
            ></van-nav-bar>
            <van-search v-model="keywords" placeholder="请输入合同名称或编号" @change="search"></van-search>
            <div class="project-list">
                <van-list
                    v-model="loading"
                    :finished="finished"
                    finished-text="没有更多了"
                    @load="onLoad"
                    v-if="total"
                >
                    <div
                        class="project-item"
                        v-for="item in contractList"
                        :key="item.cvid"
                        @click="chosedContract(item)"
                    >
                        <ul>
                            <li>
                                <span class="icon icon1"></span>
                                <span>合同编号：{{ item.contract_number }}</span>
                            </li>
                            <li>
                                <span class="icon icon3"></span>
                                <span class="info">工程名称：{{ item.engineering_name }}</span>
                            </li>
                            <li>
                                <span class="icon icon4"></span>
                                <span class="info">签订日期：{{ item.signing_date }}</span>
                            </li>
                            <li>
                                <span class="icon icon2"></span>
                                <span class="info">客户名称：{{ item.client_name }}</span>
                            </li>
                        </ul>
                    </div>
                </van-list>
                <div class="no-data" v-else></div>
            </div>
        </div>
    </v-touch>
</template>

<script>
export default {
    name: 'collection-select-contract',
    components: {},
    props: {},
    data() {
        return {
            MobilePhone: '',
            pageindex: 0,
            contractList: [],
            formData: {},
            loading: false,
            finished: false,
            total: true,
            keywords: '',
        };
    },
    watch: {},
    computed: {},
    created() {},
    mounted() {
    },
    methods: {
        // 返回上一页
        swiperright() {
            this.$router.isBack = 1;
            this.$router.go(-1);
        },
        // 搜索
        search() {
            this.pageindex = 0;
            this.contractList = [];
            this.onLoad();
        },
        // 数据分页加载
        onLoad() {
            this.pageindex++;
            this.$axios
                // eslint-disable-next-line max-len
                .get(`/interfaceApi/sale/accounts/proceeds/get_proceeds_choose_contract?keyword=${this.keywords}&pageindex=${this.pageindex}&pageSize=5`)
                .then(res => {
                    this.loading = false;
                    if (res.total) {
                        this.total = true;
                        this.contractList = this.contractList.concat(res.rows);
                        if (this.contractList.length >= res.total) {
                            this.finished = true;
                        }
                    } else {
                        this.total = false;
                        this.finished = true;
                    }
                }).catch(error => {
                    this.$toast(error.ErrorCode.Message);
                });
        },

        // 选中合同
        chosedContract(data) {
            this.$router.isBack = 1;
            this.$router.replace({
                name: 'addCollectionRecord',
                params: {
                    contractData: data,
                },
            });
            this.$router.go(-1);
        },
    },

};
</script>
<style lang="stylus">
.collectionSelectContract
    height calc(100% - 44rpx)
    .back
        position absolute
        top 10rpx
        left 15rpx
        z-index 10000
        color #fff
    .project-list
        height 100%
        overflow-y auto
        overflow-x hidden
        background #F0F0F0
        .van-list
            padding-bottom 60rpx
            .project-item
                padding 12rpx
                background #fff
                margin 12rpx 12rpx 0 12rpx
                position relative
                .icon
                    width 18rpx
                    height 18rpx
                    display inline-block
                    vertical-align middle
                    margin-right 10rpx
                    &:before
                        content ' '
                        width 16rpx
                        height 16rpx
                        display inline-block
                        background-repeat no-repeat
                        background-size 100% 100%
                    &.icon1
                        &:before
                            background-image url(./../../../assets/images/icons/icon_gy_3.png)
                    &.icon2
                        &:before
                            background-image url(./../../../assets/images/icons/icon_gy_1.png)
                    &.icon3
                        &:before
                            background-image url(./../../../assets/images/icons/icon_gy_8.png)
                    &.icon4
                        &:before
                            background-image url(./../../../assets/images/icons/icon_gy_7.png)
                .info
                    color #666666
                    font-size 14rpx
                li
                    margin-bottom 10rpx
                .state
                    position absolute
                    top 0
                    right 0
                    font-weight 400
                    width 40rpx
                    height 40rpx
                    &:before
                        font-size 40rpx
                        line-height 40rpx
                        color #FF6600
                        position absolute
                        top 0px
                        right 0
                    i
                        position absolute
                        width 40rpx
                        text-align center
                        font-size 12rpx
                        color #FFFFFF
                        transform rotate(45deg)
                        top 7rpx
                        left 7rpx

</style>
